import { Outlet } from 'react-router-dom';

export const RoleRoute = () => {
    return <Outlet />;
};
